export default "__VITE_ASSET__BNkovqGQ__"